import $ from 'jquery';
import 'magnific-popup';

export function initMagnificPopup() {
    if($('.mfp-trigger')) {
        $('.mfp-trigger').magnificPopup({
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
    }
}
